import { inject, Injectable } from '@angular/core';
import {
  MissingTranslationHandler,
  MissingTranslationHandlerParams,
  TranslateParser
} from '@ngx-translate/core';

export const ENGLISH_DEFAULT_TEXT_PARAM = 'defaultText';

@Injectable()
export class EnglishDefaultMissingTranslationHandler implements MissingTranslationHandler {
  private readonly parser = inject(TranslateParser);

  handle(params: MissingTranslationHandlerParams): string {
    const interpolationParams = params.interpolateParams as Record<string, unknown> | undefined;
    const defaultText = interpolationParams?.[ENGLISH_DEFAULT_TEXT_PARAM];

    if (typeof defaultText !== 'string') {
      return params.key;
    }

    return this.parser.interpolate(defaultText, params.interpolateParams) ?? defaultText;
  }
}
